import { constVoid, identity } from 'fp-ts/function';
import * as TE from 'fp-ts/TaskEither';
export var unify = identity;
export var unit = TE.of(constVoid());